module.exports = __webpack_public_path__ + "static/media/begamble.64593057.png";